export class Survey {
  interview_count;
  interview_period;
  margin_error;
  confidence_level;
  methodology;
  final_considerations;

  constructor(
    sample,
    field_period,
    error_margin,
    trust,
    method,
    considerations
  ) {
    this.interview_count = sample;
    this.interview_period = field_period;
    this.margin_error = error_margin;
    this.confidence_level = trust;
    this.methodology = method;
    this.final_considerations = considerations;
  }
}

export class ReportObject {
  surveyTitle;
  survey;
  client_name;
  customization;

  constructor(pageTitle, survey, clientName, customizationObject) {
    this.surveyTitle = pageTitle;
    this.survey = survey;
    this.client_name = clientName;
    this.customization = customizationObject;
  }
}

export class Question {
  id;
  title;

  constructor(id, enunciando) {
    this.id = id;
    this.title = enunciando;
  }
}